import { createSelector, createReducer } from 'redux-starter-kit';

import {
  search
} from './actions';

const initialState = {
  providers: [],
  fetching: false,
  error: false
}

export const getProviders = createSelector(
  ['providerSearch.providers'],
  providers => providers
)

export const isFetching = createSelector(
  ['providerSearch.fetching'],
  fetching => Boolean(fetching)
)

export const hasError = createSelector(
  ['providerSearch.error'],
  error => Boolean(error)
)

export const reducer = createReducer(initialState, {
  [search.failure]: (state, action) => {
    console.error("Search Failture Exception: %o", action);
    return {...state, fetching: false, providers: [], error: true} 
  },
  [search.start]: (state, action) => { return {...state, fetching: true, providers: [], error: false} },
  [search.success]: (state, action) => { return { ...state, providers: action.payload, fetching: false, error: false } }
});
